import { DollarSignIcon } from 'lucide-react';
import { twMerge } from 'tailwind-merge';

import { CardContainer, SectionHeading } from '@/_containers';
import { dashboardWidgetsPermissionConfig } from '@/_shared';

export function Layout({
  children,
  className,
  title = dashboardWidgetsPermissionConfig['recurring_revenue_variance'].name,
}: {
  children: React.ReactNode;
  className?: string;
  title?: string;
}) {
  return (
    <CardContainer
      className={twMerge('@container h-full', className)}
      bodyClassName="3xl:px-4 @container flex h-full flex-col items-start px-4 pb-4"
      right
    >
      <div className="h-10 w-full shrink-0">
        <SectionHeading text={title} icon={DollarSignIcon} />
      </div>
      <div className="mt-4 w-full flex-1">{children}</div>
    </CardContainer>
  );
}
